// https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill
var arrayFrom = require('array-from');

if (!Element.prototype.matches) {
    Element.prototype.matches = 
        Element.prototype.matchesSelector || 
        Element.prototype.mozMatchesSelector ||
        Element.prototype.msMatchesSelector || 
        Element.prototype.oMatchesSelector || 
        Element.prototype.webkitMatchesSelector ||
        function(s) {
            var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                i = matches.length;
            while (--i >= 0 && matches.item(i) !== this) {} //eslint-disable-line
            return i > -1;
        };
}

/**
 * Element.closest() polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
 */
if (!Element.prototype.closest) {
    Element.prototype.closest = function (s) {
        // var el = this;
        var ancestor = this;
        // if (!document.documentElement.contains(el)) return null;
        do {
            if (ancestor.matches(s)) return ancestor;
            ancestor = ancestor.parentElement;
        } while (ancestor !== null);
        return null;
    };
}

export class Events{
    constructor(){
        this.events = {}; // Stores a map of event listeners
    }

    once (eventName, callback){
        let onceFunc = () => {
            removeListener();
            callback(arguments);
        }

        let removeListener = () => {
            this.off(eventName, onceFunc);
        }

        this.on(eventName, onceFunc);
    }

    off (eventName, callback){
        if(this.events[eventName]){
            this.events[eventName].forEach( (func, i) => {
                if(func === callback){
                    this.events[eventName].splice(i, 1);
                }
            });
        }
    }

    on (eventName, callback){

        if(eventName && typeof eventName === "string"){
            eventName = eventName.trim(); // remove leading/trailing whitespace
        }else{
            throw new Error("Can not make event listener. Expected string as input, but got: " + typeof eventName);
        }

        // Check if we have multiple input event names seperated by space
        var eventNames = eventName.split(" ")
            .map( (str) => { return str.trim(); }) // remove whitespaces on each term. This will convert terms of only spaces to empty terms
            .filter( ( str ) => { return str.length > 0 } ); // Now remove empty terms and remain with only valid strings


        if(eventNames.length > 1){
            // We still have multiple terms, so do this whole thing recursively on the terms
            eventNames.forEach( (name) => {
                this.on( name, callback );
            } );

        }else if(eventNames.length === 1){
            // Just one term, register a handler for it
            var name = eventNames[0];

            if(!this.events[name]){
                // Make an empty array of events if one does not already exist
                this.events[name] = [];
            }

            //TODO: handle multiple space-seperated strings in the eventName
            // cut it up and apply the listener multiple times

            this.events[name].push(callback);
        }

    }

    trigger (){
        const args = arrayFrom(arguments);
        const eventName = args.shift();

        if(eventName && this.events[eventName]){
            this.events[eventName].forEach( (func) => {
                func.apply(this, args);
            });
        }
    }
}

export function onChildEvent (rootElement, eventName, className, callback, context, stopPropagation){
    rootElement.addEventListener(eventName, function(event) {

        if(stopPropagation !== false){
            event.stopPropagation();
        }

        var target = event.target;
        if(target.classList.contains(className) ) {
            if(callback && context){
                callback.call(context, event);
            }else if(callback){
                callback(event);
            }
        }
    });
}

export function triggerElementEvent(element, eventName){
    var event;
    if (typeof CustomEvent === 'function') {
        event = new CustomEvent(eventName, {bubbles: true, cancelable: true});
    }else{
        event = document.createEvent('Event');
        event.initEvent(eventName, true, true); //can bubble, and is cancellable
    }

    element.dispatchEvent(event);
}


export class ElementWrapper{
    constructor (element){
        this.element = element;
    }

    on (eventName, callback){
        this.element.addEventListener(eventName, callback);
    }

    off (eventName, callback){
        this.element.removeElementListener(eventName, callback);
    }

    onChildEvent(eventName, className, callback){
        onChildEvent(this.element, eventName, className, callback);
    }

    trigger(eventName/*, params*/){
        triggerElementEvent(this.element, eventName);
    }

    find(query){
        return this.element.querySelectorAll(query);
    }
}


export function wrapElement( elem ){
    return new ElementWrapper( elem );
}


// WEBPACK FOOTER //
// src/utils/Events.js